import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { setUpLocationSync } from "@angular/router/upgrade";
import { AppModule } from "./src/app/app.module";
import { get } from "scriptjs";
import { environment } from "./src/environments/environment";

// Enable production mode if the environment is production
if (environment.production) {
  enableProdMode();
}

get("https://cdnjs.cloudflare.com/ajax/libs/d3/5.16.0/d3.js", () => {});
get(
	environment.production
		? "https://pspdfkit.cipo.cloud/nutrient-viewer.js"
		: "https://pspdfkit-dev.cipo.cloud/nutrient-viewer.js",
	() => {},
);

platformBrowserDynamic()
	.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
	.then((ref) => {
		const upgrade = (<any>ref.instance).upgrade;
		// bootstrap angular1
		upgrade.bootstrap(document.body, ["cipo"]);
		setUpLocationSync(upgrade);
	});
